import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Activites } from '../_models/activites';
import { Batch } from '../_models/batch-number';
import { Nip } from '../_models/nip';
import { NipStart } from '../_models/nip-start';
import { NipStop } from '../_models/nip-stop';
import { SaveNip } from '../_models/save-nip';

@Injectable({
  providedIn: 'root',
})
export class NipService {
  updateNipData = new BehaviorSubject<Nip>(null);
  // When user go to Add NIP and then click to add partners
  saveFormData = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) {}

  getAllNip() {
    return this.http.get<Nip[]>(`${environment.apiUrl}/api/nips`).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  getNipById(id: number) {
    return this.http.get<Nip[]>(`${environment.apiUrl}/api/nips/${id}`);
  }

  getReport(id: number) {
    return this.http.get<any>(`${environment.apiUrl}/api/nips/report/${id}`);
  }

  getCreateData() {
    return this.http.get<any>(`${environment.apiUrl}/api/nips/create`).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  exportToPDF(nipId: number) {
    return this.http
      .get<any>(`${environment.apiUrl}/api/nips/${nipId}/pdf`)
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  exportToCSV(nipId: number) {
    return this.http
      .get<any>(`${environment.apiUrl}/api/nips/${nipId}/excel`)
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  exportZK(nipId: number) {
    return this.http
      .get<any>(`${environment.apiUrl}/api/nips/${nipId}/izvestaj-kontrole-pdf`)
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  exportControlSheetToPDF(nipId: number) {
    return this.http
      .get<any>(`${environment.apiUrl}/api/nips/${nipId}/kontrolni-list-pdf`)
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }
  getActivites(nipId: number, pageIndex: number) {
    return this.http
      .get<Activites>(
        `${environment.apiUrl}/api/nips/${nipId}/activities?page=${pageIndex}`
      )
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  deleteNip(nipId: number) {
    return this.http.delete(`${environment.apiUrl}/api/nips/${nipId}`);
  }

  updateNip(nipId: number, nip: Nip) {
    return this.http.patch<Nip>(`${environment.apiUrl}/api/nips/${nipId}`, nip);
  }

  addNip(nip: Nip) {
    return this.http.post<Nip>(`${environment.apiUrl}/api/nips`, nip);
  }

  // * Nip for workers === //

  // *
  getAllWorkerNips() {
    return this.http.get<Nip[]>(`${environment.apiUrl}/api/work_orders`).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  // * Start nip
  startNip(nipId: number, nipStart: NipStart) {
    return this.http.post<NipStart>(
      `${environment.apiUrl}/api/nips/${nipId}/work_logs/start`,
      nipStart,
      { observe: 'response' }
    );
  }

  // * Stop nip
  stopNip(nipId: number, nipStop: NipStop) {
    return this.http.post<NipStop>(
      `${environment.apiUrl}/api/nips/${nipId}/work_logs/stop`,
      nipStop
    );
  }

  // * Save nip
  saveNip(nipId: number, saveNip: SaveNip) {
    return this.http.post<SaveNip>(
      `${environment.apiUrl}/api/nips/${nipId}/work_logs/save`,
      saveNip
    );
  }

  // * Start Pause
  startPause(nipId: number, nip: any) {
    return this.http.post<SaveNip>(
      `${environment.apiUrl}/api/nips/${nipId}/work_logs/start_break`,
      nip
    );
  }

  // * Stop Pause
  stopPause(nipId: number, nip: any) {
    return this.http.post<SaveNip>(
      `${environment.apiUrl}/api/nips/${nipId}/work_logs/stop_break`,
      nip
    );
  }

  // * Stop Pause
  savePause(nipId: number, nip: any) {
    return this.http.post<SaveNip>(
      `${environment.apiUrl}/api/nips/${nipId}/work_logs/save_break`,
      nip
    );
  }

  // * Cancel nip
  cancelNip(nipId: number, nipCancel: NipStop) {
    return this.http.post<NipStop>(
      `${environment.apiUrl}/api/nips/${nipId}/work_logs/cancel`,
      nipCancel
    );
  }

  updateTimeTracker(dataId: number, data: any) {
    return this.http.patch<Nip>(
      `${environment.apiUrl}/api/work_logs/${dataId}`,
      data
    );
  }

  deleteTimeTracker(dataId: number) {
    return this.http.delete(`${environment.apiUrl}/api/work_logs/${dataId}`);
  }

  /**
   * IMPROVED NIP
   */
  getAllNips(pageIndex: number, perPage: number, queryParams) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/nips?page=${pageIndex}&per_page=${perPage}&${queryParams}`
    );
  }

  delete(nipId: number) {
    return this.http.delete(`${environment.apiUrl}/api/nips/${nipId}`);
  }

  getOne(nipId: number) {
    return this.http.get<Nip[]>(`${environment.apiUrl}/api/nips/${nipId}`);
  }

  getAllWorkNips(pageIndex: number, perPage: number, queryParams) {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/work_orders?page=${pageIndex}&per_page=${perPage}&${queryParams}`
    );
  }
  getOneWorkNip(nipId: number) {
    return this.http.get<Nip[]>(`${environment.apiUrl}/api/nips/${nipId}`);
  }

  getPartners(pageIndex: number, perPage: number, searchTerm) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/partners?page=${pageIndex}&per_page=${perPage}&company=${searchTerm}`
    );
  }

  getProducts(pageIndex: number, perPage: number, search) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/products?page=${pageIndex}&per_page=${perPage}&name=${search}`
    );
  }
}
